import {
  CLEAR_BATCH_BY_DATE,
  CLEAR_TRANSACTIONS_BY_BATCH,
  GET_BATCH_BY_DATE_SUCCESS,
  GET_TRANSACTIONS_BY_BATCH,
} from "../actions/batch";

const initialState = {
  batchData: [],
  individualBatchInfo: {},
  individualBatchTransactions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BATCH_BY_DATE_SUCCESS:
      return { ...state, batchData: action.payload };

    case CLEAR_BATCH_BY_DATE:
      return { ...state, batchData: [] };

    case GET_TRANSACTIONS_BY_BATCH:
      return {
        ...state,
        individualBatchInfo: action.individualBatchInfo,
        individualBatchTransactions: action.individualBatchTransactions,
      };
    case CLEAR_TRANSACTIONS_BY_BATCH:
      return {
        ...state,
        individualBatchInfo: {},
        individualBatchTransactions: [],
      };
    default:
      return state;
  }
};
